<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.rolepermission') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table
        tableClass="table-bordered"
        hidePagination>
        <template #thead>
          <thead>
            <tr>
              <th style="width: 300px;">{{ $t('apps.settings.message.roletitle') }}</th>
              <th>{{ $t('apps.settings.message.rolepermissions') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="isEmpty"
                colspan="2"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'SettingsRolePermissionEdit',
                    query: {
                      id: item.permissionId,
                      title: item.title,
                    }
                }">
                  {{ item.title }}
                </router-link>
              </td>
              <td>
                <span
                  v-for="(permission, index) in item.permissions"
                  :key="index"
                  :class="'badge badge-secondary'"
                  :style="'margin-right: 5px;background:'+$t(getAppInfo(permission.app_id).translate + '.bgcolor')"
                >
                  <i :class="$t(getAppInfo(permission.app_id).translate + '.icon')"/>
                  {{ $t(getAppInfo(permission.app_id).translate + '.title') }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'

export default {
  mixins: [tablePaginateMixin],

  data () {
    return {
      loading: true,
      // keep `query` exist because we use with `tablePaginateMixin`
      query: {},
    }
  },

  computed: {
    ...mapState('rolePermission', {
      data: 'rolePermissionList',
    }),
    ...mapGetters({
      getAppInfo: 'getAppInfo',
    }),
    isEmpty () {
      return !this.data.length
    },
  },

  watch: {
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.fetchData()
      }
    },
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('rolePermission', {
      getRolePermissionList: 'getRolePermissionList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getRolePermissionList()
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/rolepermission/List.vue